module.exports = __webpack_public_path__ + "img/04_BC5_become_party.c8275af5.jpg";